// routes
import { PATH_HOME } from './paths';

export const MENU_OPTIONS = [
  {
    label: 'Home',
    linkTo: PATH_HOME.root,
  },
];
